import { render, staticRenderFns } from "./SuccessMsg.vue?vue&type=template&id=69503f66&scoped=true&"
import script from "./SuccessMsg.vue?vue&type=script&lang=js&"
export * from "./SuccessMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69503f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
